import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { from } from 'rxjs/observable/from';

import { OrganizationsService } from '../../services';
import setOrgs from '../../reducers/organizations/actions/setOrgs';

import {
  types as actions, getOrgSitesAction, setOrgAction, getSitesAction
} from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function (action$, store) {
  return action$.pipe(
    ofType(actions.GET_ORGS),
    switchMap(action =>
      OrganizationsService.getOrgs(store).pipe(
        switchMap(data => {
          let currentOrgId = localStorage.getItem('orgId');
          let cnt = data.response.length;
          let currentOrg = data.response.find(org => org.id === currentOrgId) || data.response[0];
          if(cnt === 1){
            localStorage.setItem('orgId', currentOrg.id)
          }
          let setorgs = setOrgs(data.response, cnt)
          if(cnt === 1 || (currentOrgId && currentOrg)){
            return from([
              setorgs,
              setOrgAction(currentOrg),
              getOrgSitesAction(currentOrg.id, true, true),
            ])
          }else if(cnt > 1){
            return from([setorgs])
          }else{
            return from([setorgs, getSitesAction(true, true)])
          }
        }),
        catchError(retryAuthentication(action$, 'epics/organizations/getOrgs'))
      ))
  )
}



// WEBPACK FOOTER //
// ./src/epics/organizations/getOrgs.js